export default {
  "hero.badge": "भारत की शीर्ष IT कंपनी",
  "hero.title": "हम बनाते हैं",
  "hero.title.highlight": "विश्व-स्तरीय सॉफ्टवेयर",
  "hero.subtitle": "200+ इंजीनियर Fortune 500 कंपनियों के लिए एंटरप्राइज सॉफ्टवेयर बना रहे हैं। AI-संचालित, क्लाउड-नेटिव, भविष्य-तैयार डिजिटल समाधान।",
  "hero.cta1": "मुफ्त परामर्श प्राप्त करें",
  "hero.cta2": "शोरील देखें",
  "stats.projects": "प्रोजेक्ट्स पूर्ण",
  "stats.clients": "ग्राहक सेवित",
  "stats.countries": "देश कवर",
  "stats.industries": "उद्योग सेवित",
  "stats.years": "वर्षों का अनुभव",
  "stats.software": "सॉफ्टवेयर उत्पाद",
  "stats.satisfaction": "ग्राहक संतुष्टि",
  "stats.tickets": "समर्थन टिकट हल",
  "nav.home": "होम",
  "nav.services": "सेवाएं",
  "nav.portfolio": "पोर्टफोलियो",
  "nav.industries": "उद्योग",
  "nav.caseStudies": "केस स्टडी",
  "nav.blogs": "ब्लॉग",
  "nav.about": "हमारे बारे में",
  "nav.contact": "संपर्क",
  "nav.careers": "करियर",
  "nav.calculators": "कैलकुलेटर",
  "testimonials.title": "हमारे ग्राहकों का",
  "testimonials.title.highlight": "क्या कहना है",
  "testimonials.subtitle": "12 देशों में 500+ व्यवसायों द्वारा विश्वसनीय",
  "map.title": "वैश्विक",
  "map.title.highlight": "उपस्थिति",
  "map.subtitle": "दुनिया भर के 12+ देशों में ग्राहकों की सेवा",
  "cta.book": "परामर्श बुक करें",
  "cta.call": "कॉल करें",
  "cta.whatsapp": "व्हाट्सएप",
  "cta.quote": "कोटेशन लें",
  "cta.email": "ईमेल करें",
  "cta.demo": "डेमो बुक करें",
  "search.placeholder": "सेवाएं, ब्लॉग, पोर्टफोलियो खोजें...",
  "search.noResults": "कोई परिणाम नहीं मिला",
  "search.allResults": "सभी परिणाम देखें",
  "footer.newsletter": "न्यूज़लेटर",
  "footer.newsletter.desc": "टेक, AI और रणनीति पर साप्ताहिक जानकारी।",
  "footer.subscribe": "सब्सक्राइब करें",
  "footer.copyright": "सर्वाधिकार सुरक्षित।",
  "footer.iso": "ISO 27001 प्रमाणित",
  "footer.gdpr": "GDPR अनुरूप",
  "footer.cmmi": "CMMI स्तर 3",
  "lang.switch": "भाषा बदलें",
  "lang.en": "English",
  "lang.hi": "हिन्दी",
}